import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import {
  createWarehouse,
  getBrandWarehouseById,
  putWarehouse,
} from "../../../services/warehouse/Warehouse";
import {
  addBrandOffer,
  getBrandSingleOffer,
  getOfferCategory,
  getOfferType,
  updateBrandOffer,
} from "../../../services/OfferManagements/OfferManagementConfig";
import { getBrandAppService } from "../../../services/BrandAppServices";
import { getBrandPriceCode } from "../../../services/StorePriceCode/getPriceCode";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import {
  addPackageOffer,
  getSinglePackageOffer,
  updatePackageOffer,
} from "../../../services/PaymentOfferManagement/PackageOfferManagement";
import AdminMenu from "../../AdminMenu";

const PackageOfferCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {}; // Fallback to prevent undefined errors
  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  const [isUpdating, setIsUpdating] = useState(id);
  const [singleOfferData, setSingleOfferData] = useState({});
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [showValidToDatePicker, setShowValidToDatePicker] = useState(false);
  const [showValidFromDatePicker, setShowValidFromDatePicker] = useState(false);
  const [appServiceList, setAppServiceList] = useState([]);

  const [selectedGarment, setSelectedGarment] = useState("");
  const [offerCategory, setOfferCategory] = useState([]);
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  let initialDate = new Date();
  const minimumDate = new Date();
  //  minimumDate.setMonth(minimumDate.getMonth() + 3); // Add 3 months to current date

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 100);

  const maximumValidDate = maximumDate;

  const [input, setInput] = useState({
    offerName: "",
    offerCategory: "",
    // offerValue: '',
    packageValue: "",
    serviceValue: "",
    validTo: new Date(initialDate),
    validFrom: new Date(initialDate),
    status: "ACTIVE",
    carryForward: "TRUE",
    validity: "",
  });

  const fetchSingleOfferData = (id) => {
    getSinglePackageOffer(brandId, id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setSingleOfferData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    if (isUpdating !== null) {
      fetchSingleOfferData(isUpdating);
    }
  }, [isUpdating]);

  const fetchOffersData = () => {
    getBrandAppService(brandId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          setAppServiceList(res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getOfferCategory()
      .then((response) => {
        if (!response.data.error) {
          const res = response.data.filter((item) => item.name === "SERVICE");
          // setInput({
          //   ...input,
          //   offerCategory: res[0].id,
          // });
          setOfferCategory(res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchOffersData();
  }, []);

  useEffect(() => {
    if (singleOfferData) {
      setInput((prevState) => ({
        ...prevState,
        offerName: singleOfferData?.name || "",
        offerCategory:
          singleOfferData?.offerCategory?.id || offerCategory[0]?.id,
        // offerValue: singleOfferData?.value?.toString() || '',
        packageValue: singleOfferData?.packageValue?.toString() || "",
        serviceValue: singleOfferData?.serviceValue?.toString() || "",
        validTo: singleOfferData?.validTo
          ? new Date(singleOfferData?.validTo)
          : new Date(initialDate),
        validFrom: singleOfferData?.validFrom
          ? new Date(singleOfferData?.validFrom)
          : new Date(initialDate),
        status: singleOfferData?.status || "ACTIVE",
        carryForward:
          singleOfferData?.carryForward === "TRUE" ? true : false || "TRUE",
        validity: singleOfferData?.validity?.toString() || "",
      }));
      setSelectedGarment(singleOfferData?.priceId || "");
    }
  }, [singleOfferData]);

  const [offerNameError, setOfferNameError] = useState("");
  const [offerCategoryError, setOfferCategoryError] = useState("");
  const [validToError, setValidToError] = useState("");
  const [validFromError, setValidFromError] = useState("");
  const [statusError, setStatusError] = useState("");
  const [carryForwardError, setCarryForwardError] = useState("");
  const [serviceError, setServiceError] = useState("");
  const [garmentError, setGarmentError] = useState("");
  // const [offerValueError, setOfferValueError] = useState('');
  const [packageValueError, setPackageValueError] = useState("");
  const [serviceValueError, setServiceValueError] = useState("");
  const [validityError, setValidityError] = useState("");

  const handleStatusChange = (selectedItem) => {
    // setStatusValue(selectedItem.value);
    setInput({
      ...input,
      status: selectedItem.value,
    });
  };
  const handleCarryForwardChange = (selectedItem) => {
    // setCarryForwardValue(selectedItem.value)
    setInput({
      ...input,
      carryForward: selectedItem.value,
    });
  };

  const StatusList = [
    {
      name: "ACTIVE",
      value: "ACTIVE",
    },
    {
      name: "INACTIVE",
      value: "INACTIVE",
    },
  ];

  const carryForwardList = [
    {
      name: "TRUE",
      value: "TRUE",
    },
    {
      name: "FALSE",
      value: "FALSE",
    },
  ];

  const [selectAll, setSelectAll] = useState(true); // State for "All"

  const handleGarmentsToggle = (garment) => {
    // const updatedGarment = [garment];
    setSelectedGarment(garment);
    setGarmentError("");
  };

  const handleValidFromDateChange = (selectedDate) => {
    if (selectedDate !== undefined) {
      // Prevent selection of previous dates
      // setErrorMessage('');
      if (selectedDate <= maximumValidDate) {
        if (selectedDate < input.validTo) {
          const utcDate = new Date(
            Date.UTC(
              selectedDate.getFullYear(),
              selectedDate.getMonth(),
              selectedDate.getDate()
            )
          );
          setInput({
            ...input,
            validFrom: utcDate,
          });
          setValidFromError(""); // Clear any previous errors
        } else {
          const utcDate = new Date();
          setInput({
            ...input,
            validFrom: utcDate,
          });
          setValidFromError(
            "Valid From Date can not be greater than Valid To Date"
          );
        }
      }
    }
    setShowValidFromDatePicker(false);
  };

  const handleValidToDateChange = (selectedDate) => {
    if (selectedDate !== undefined) {
      // Prevent selection of previous dates
      if (selectedDate >= input.validFrom) {
        const utcDate = new Date(
          Date.UTC(
            selectedDate.getFullYear(),
            selectedDate.getMonth(),
            selectedDate.getDate()
          )
        );
        setInput({
          ...input,
          validTo: utcDate,
        });
        setValidToError(""); // Clear any previous errors
        setValidFromError("");
      } else {
        setValidToError("Valid To Date can not be less than Valid From Date");
      }
    }
    setShowValidToDatePicker(false);
  };

  const handleSubmit = () => {
    // Reset all previous errors
    setOfferNameError("");
    setOfferCategoryError("");
    setValidToError("");
    setValidFromError("");
    setStatusError("");
    setCarryForwardError("");
    // setOfferValueError('');
    setPackageValueError("");
    setServiceValueError("");
    setValidityError("");

    let isValid = true;
    if (!input.offerName) {
      setOfferNameError("Offer Name is Required");
      isValid = false;
    }
    if (!input.offerCategory) {
      setOfferCategoryError("Offer Category is Required");
      isValid = false;
    }
    // if (!input.offerValue) {
    //   setOfferValueError('Value can not be Empty');
    //   isValid = false;
    // }
    if (!input.packageValue) {
      setPackageValueError("Package Value can not be Empty");
      isValid = false;
    }
    if (!input.serviceValue) {
      setServiceValueError("Service Value can not be Empty");
      isValid = false;
    }
    if (parseFloat(input.packageValue) >= parseFloat(input.serviceValue)) {
      setPackageValueError("Package Value must be less than Service Value");
      isValid = false;
    }
    if (!input.validFrom) {
      setValidToError("Valid From date is Required");
      isValid = false;
    }
    if (!input.validTo) {
      setValidFromError("Valid To Date is Required");
      isValid = false;
    }
    if (!input.status) {
      setStatusError("Status is Required");
      isValid = false;
    }
    if (!input.carryForward) {
      setCarryForwardError("Carry Forward is Required");
      isValid = false;
    }
    // if (input.offerCategory === 1 && selectedServices.length <= 0) {
    //   setServiceError('Please Select Services is Required');
    //   isValid = false;
    // }
    if (!input.validity) {
      setValidityError("validity is Required");
      isValid = false;
    }

    // if (input.offerCategory === 2 && selectedGarment === '') {
    //   setGarmentError('Please Select Tariff is Required');
    //   isValid = false;
    // }
    // addBrandOffer;
    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (!isUpdating) {
          // Logic for creating a new pickup request
          const data = {
            brandId: brandId,
            priceId: selectedGarment ? selectedGarment : null, // null for service
            name: input.offerName,
            // value: input.offerValue,
            packageValue: input.packageValue,
            serviceValue: input.serviceValue,
            validity: input.validity,
            offerCategory: {
              id: input.offerCategory,
            },
            applyOn: "ALL",
            validFrom: input.validFrom.toISOString(),
            validTo: input.validTo.toISOString(),
            status: input.status,
            carryForward: input.carryForward === "TRUE" ? true : false,
            // itemList: selectedServices.length > 0 ? selectedServices : [],
            itemList:
              input.offerCategory === 1
                ? appServiceList?.map((item) => item.appService.id)
                : [],
          };

          // Call the service function for creating pickup request

          addPackageOffer(brandId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  // Reset state variables
                  if (Res.status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(Res.message);
                    setTimeout(() => {
                      navigate("/PackageOfferManagement");
                    }, 1500);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(Res.message);
                  }

                  setInput({
                    offerName: "",
                    //        offerValue: '',
                    packageValue: "",
                    serviceValue: "",
                    validity: "",
                    offerCategory: "",
                    validTo: new Date(initialDate),
                    validFrom: new Date(initialDate),
                    status: "",
                    carryForward: "",
                  });
                  // setSelectedServices([]);
                  setSelectedGarment([]);

                  setOfferNameError("");
                  //       setOfferValueError('');
                  setPackageValueError("");
                  setServiceValueError("");
                  setValidityError("");
                  setOfferCategoryError("");
                  setValidToError("");
                  setValidFromError("");
                  setStatusError("");
                  setCarryForwardError("");
                  setIsSubmitButtonPressed(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          const updateData = {
            id: id, // id
            brandId: brandId,
            priceId: selectedGarment ? selectedGarment : null, // null for service
            name: input.offerName,
            // value: input.offerValue,
            packageValue: input.packageValue,
            serviceValue: input.serviceValue,
            validity: input.validity,
            offerCategory: {
              id: input.offerCategory,
            },
            applyOn: "ALL",
            validFrom: input.validFrom.toISOString(),
            validTo: input.validTo.toISOString(),
            status: input.status,
            carryForward: input.carryForward === "TRUE" ? true : false,
            // itemList: selectedServices.length > 0 ? selectedServices : [],
            itemList:
              input.offerCategory === 1
                ? appServiceList?.map((item) => item.appService.id)
                : [],
          };

          // Call the service function for creating pickup request
          updatePackageOffer(brandId, updateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  // Reset state variables
                  if (Res.status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(Res.message);
                    setTimeout(() => {
                      navigate("/PackageOfferManagement");
                    }, 1500);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(Res.message);
                  }

                  setInput({
                    offerName: "",
                    offerValue: "",
                    packageValue: "",
                    serviceValue: "",
                    validity: "",
                    offerCategory: "",
                    validTo: new Date(initialDate),
                    validFrom: new Date(initialDate),
                    status: "",
                    carryForward: "",
                  });
                  // setSelectedServices([]);
                  setSelectedGarment([]);

                  setOfferNameError("");
                  //   setOfferValueError('');
                  setPackageValueError("");
                  setServiceValueError("");
                  setValidityError("");
                  setOfferCategoryError("");
                  setValidToError("");
                  setValidFromError("");
                  setStatusError("");
                  setCarryForwardError("");
                  setIsSubmitButtonPressed(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsSubmitButtonPressed(false);
    }
  };

  // const validTo = new Date('2024-06-17T00:00:00.000Z');
  const validTo = new Date(input.validTo);
  const currentDate = new Date();
  // Calculate the difference in milliseconds
  const timeDifference = validTo - currentDate;

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/PackageOfferManagement")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Store Subscription {id ? "Edit " : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="offerName"
              value={input.offerName}
              onChange={(e) => {
                setInput({
                  ...input,
                  offerName: e.target.value,
                  offerCategory: offerCategory[0]?.id,
                });
                setOfferNameError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {offerNameError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {offerNameError}
              </p>
            )}

            <label
              htmlFor="offerName"
              className="text-md"
              style={{ color: "blue" }}
            >
              Offer Name <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="offerCategory"
              value={"SERVICE"}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              disabled={true}
            />

            <label
              htmlFor="offerCategory"
              className="text-md"
              style={{ color: "blue" }}
            >
              Offer Category <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="packageValue"
              value={input.packageValue}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setInput({
                    ...input,
                    packageValue: value,
                  });
                  setPackageValueError("");
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {packageValueError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {packageValueError}
              </p>
            )}

            <label
              htmlFor="packageValue"
              className="text-md"
              style={{ color: "blue" }}
            >
              Package Value <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="serviceValue"
              value={input.serviceValue}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setInput({
                    ...input,
                    serviceValue: value,
                  });
                  setServiceValueError("");
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {serviceValueError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {serviceValueError}
              </p>
            )}

            <label
              htmlFor="serviceValue"
              className="text-md"
              style={{ color: "blue" }}
            >
              Service Value <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <div className="flex-auto">
            <FloatLabel>
              <Calendar
                id="ValidFromDatePicker"
                value={input.validFrom}
                onChange={(e) => {
                  handleValidFromDateChange(e.target.value);
                }}
                showIcon
                minDate={minimumDate}
                maxDate={input.validTo}
                disabled={timeDifference < 0 ? true : false}
                className="w-full  bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
                dateFormat="dd/mm/yy"
              />
              <label
                htmlFor="ValidFromDatePicker"
                className="text-md"
                style={{ color: "blue" }}
              >
                Valid From <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
            {timeDifference < 0 && (
              <p className="text-md font-normal p-0" style={{ color: "red" }}>
                Please Select the valid to date
              </p>
            )}
            {validFromError && (
              <p className="text-md font-normal p-0" style={{ color: "red" }}>
                {validFromError}
              </p>
            )}
          </div>
        </div>
        <div className="mx-4 mt-4 flex-1">
          <div className="flex-auto">
            <FloatLabel>
              <Calendar
                id="ValidToDatePicker"
                value={input.validTo}
                onChange={(e) => {
                  handleValidToDateChange(e.target.value);
                }}
                showIcon
                minDate={input.validFrom}
                maxDate={maximumValidDate}
                className="w-full  bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
                dateFormat="dd/mm/yy"
              />
              <label
                htmlFor="ValidToDatePicker"
                className="text-md"
                style={{ color: "blue" }}
              >
                Valid To <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="validity"
              value={input.validity}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setInput({
                    ...input,
                    validity: value,
                  });
                  setValidityError("");
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {validityError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {validityError}
              </p>
            )}

            <label
              htmlFor="validity"
              className="text-md"
              style={{ color: "blue" }}
            >
              Validity <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className=" mt-4 mx-4 flex-1">
          <FloatLabel>
            <Dropdown
              id="statusValue"
              value={input.status}
              onChange={(e) =>
                setInput({
                  ...input,
                  status: e.value,
                })
              }
              options={StatusList}
              optionLabel="name"
              placeholder="Status"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            {statusError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {statusError}
              </p>
            )}
            <label
              htmlFor="statusValue"
              className="text-md"
              style={{ color: "blue" }}
            >
              Status <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className=" mt-4 mx-4 flex-1">
          <FloatLabel>
            <Dropdown
              id="carryForward"
              value={input.carryForward}
              onChange={(e) =>
                setInput({
                  ...input,
                  carryForward: e.value,
                })
              }
              options={carryForwardList}
              optionLabel="name"
              placeholder="Carry Forward"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            {statusError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {statusError}
              </p>
            )}
            <label
              htmlFor="carryForward"
              className="text-md"
              style={{ color: "blue" }}
            >
              Carry Forward <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isSubmitButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default PackageOfferCreate;
